const INITIAL_STATE = {
  // True once the *whole* collection has been fetched. Partial merges (see
  // MERGE_*) deliberately leave it false, so a search that needs every row
  // can tell "a few rows are loaded" from "all of them are".
  allUsersLoaded: false,
  users: [],
  parcelsArray: [],
  bookingsArray: [],
  rechargesArray: [],
  paymentsArray: [],
  rechargeRequestArray: [],
};

const setUsersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_USERS":
      return { ...state, allUsersLoaded: true, users: [...action.payload] };
    // Adds the users a page needs without discarding ones already loaded, so
    // `users` grows to cover what has been on screen instead of being the
    // whole collection. Consumers still do `users.find(u => u.uid === id)` and
    // are unaffected. Incoming copies win, being the newer read.
    case "MERGE_USERS": {
      const incoming = action.payload || [];
      if (incoming.length === 0) return state;
      const byUid = new Map(state.users.map((user) => [user.uid, user]));
      incoming.forEach((user) => {
        if (user && user.uid) byUid.set(user.uid, user);
      });
      return { ...state, users: [...byUid.values()] };
    }
    case "RECHARGE_USER":
      const filteredUsers = state.users.filter(
        (user) => user.uid !== action.payload.uid
      );

      return {
        ...state,
        users: [action.payload, ...filteredUsers],
      };
    case "UPDATE_USER_STATUS":
      const filterUsers = state.users.filter(
        (user) => user.uid !== action.payload.uid
      );
      return {
        ...state,
        users: [action.payload, ...filterUsers],
      };

    case "GET_ALL_BOOKINGS_OF_SINGLE_USER":
      return {
        ...state,
        bookingsArray: action.payload,
      };
    case "GET_ALL_PARCELS_OF_SINGLE_USER":
      return {
        ...state,
        parcelsArray: action.payload,
      };
    case "GET_ALL_RECHARGE_REQUEST_OF_SINGLE_USER":
      return {
        ...state,
        rechargeRequestArray: action.payload,
      };
    case "GET_ALL_RECHARGE_OF_SINGLE_USER":
      return {
        ...state,
        rechargesArray: action.payload,
      };
    case "GET_ALL_PAYMENT_OF_SINGLE_USER":
      return {
        ...state,
        paymentsArray: action.payload,
      };

    default:
      return state;
  }
};
export default setUsersReducer;
